import { Dialog } from '@mui/material';
import React from 'react';
import DOMPurify from 'dompurify';

const ChatPopup = ({ open, handleClose, body }) => {
  return (
    <Dialog
      style={{ padding: '20px' }}
      open={open}
      onClose={handleClose}
      scroll="body"
    >
      <div
        style={{ padding: '20px', fontFamily: 'Inter' }}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }}
      />
    </Dialog>
  );
};

export default ChatPopup;
